import { AfterViewInit, Component, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApiService, AuthService, Landing, RegistrationModel } from 'angular-lib';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { RegistrationConstants } from '../../registration/registration.constants';
import { LoaderService } from '../../../services/loader.service';

@Component({
    selector: 'ez-landing-teaser',
    template: require('./landing-teaser.component.html'),
    styles: [require('./landing-teaser.component.less')],
    encapsulation: ViewEncapsulation.None
})
export class LandingTeaserComponent extends Landing implements OnInit, AfterViewInit {
    pics = Array(5).fill(0).map((x, i) => i + 1);
    lang: string = 'fr';
    langs = ['fr', 'en', 'es', 'pt', 'it'];
    index: number = 0;
    @ViewChild(SwiperDirective) swiperRef: SwiperDirective;

    public config: SwiperConfigInterface = {
        direction: 'horizontal',
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        scrollbar: false
    };

    constructor(
        private apiService: ApiService,
        private router: Router,
        public translateService: TranslateService,
        private registrationConstants: RegistrationConstants,
        private loader: LoaderService,
        private renderer: Renderer2
    ) {
        super();
        this.renderer.removeClass(document.body, 'member');
        this.renderer.addClass(document.body, 'public');
    }

    public ngOnInit() {
        if (this.langs.indexOf(this.translateService.currentLang) !== -1) {
            this.lang = this.translateService.currentLang
        }
    }

    public ngAfterViewInit(): void {
        // slide width update, to prevent slide width bug
        this.swiperRef.update();
    }

    public fbSignedIn(accessToken: string) {
        this.loader.show();

        this.apiService.auth({
            FBAuth: {accessToken: accessToken},
        }).subscribe((res) => {
                this.loader.hide();

                if (res.hasOwnProperty('success') && res.success === true) {
                    AuthService.login(res.jwt);
                    this.router.navigate(['member/search']);
                }
            },
            e => {
                this.apiService.post('/ws/registration/facebook', JSON.stringify({accessToken: accessToken})).subscribe((res) => {
                    // connection
                    // redirect to loggued
                    if (res.hasOwnProperty('success') && res.success === true) {
                        AuthService.login(res.jwt);

                        new RegistrationModel({
                            currentStep: this.registrationConstants.facebookFirstStep
                        }).save();

                        this.loader.hide();
                        this.router.navigate(['registration']);
                    } else {
                        // Can't register user, but populate classic register form with informations we can found
                        this.apiService.get('/f/facebook/profile?accessToken=' + accessToken)
                            .subscribe((result) => {
                            let datas: any = {};
                            if (result.data !== null) {
                                if (result.data.hasOwnProperty('email') && result.data.hasOwnProperty('email') !== null) {
                                    datas.email = result.data.email;
                                }

                                if (result.data.hasOwnProperty('first_name') && result.data.hasOwnProperty('first_name') !== null) {
                                    datas.displayName = result.data.first_name.length < 5
                                        ? result.data.first_name + '-' + Math.floor((Math.random() * 1000) + 1)
                                        : result.data.first_name;
                                }

                                if (result.data.hasOwnProperty('gender') && result.data.hasOwnProperty('gender') !== null) {
                                    datas.gender_id = result.data.gender === 'male' ? 2 : 1;
                                }

                                if (result.data.hasOwnProperty('birthday') && result.data.hasOwnProperty('birthday') !== null) {
                                    console.log(moment(result.data.birthday.date).format('DD/MM/YYYY'));
                                    datas.born_date = moment(result.data.birthday.date).format('DD/MM/YYYY');
                                }

                                let regModel = new RegistrationModel(datas);
                                regModel.save();

                                this.loader.hide();
                                this.router.navigate(['registration']);
                            }
                        });
                    }
                }, (error) => {
                    this.loader.hide();
                    this.router.navigate(['registration']);
                });
            }
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/landing/landing-teaser/landing-teaser.component.ts